export default __webpack_public_path__ + "b50d6f98713296aeb1f55568fec77d6f.png";